module.exports = __webpack_public_path__ + "media/images/shared/icon_weibo-ee92786985c90fb2bb01192e97a99b08.svg";